function modulesMatch(built, expected) {
	if (built.length !== expected.length) {
		return false;
	}
	return built.every((module) => expected.indexOf(module) !== -1);
}

function getBuildStatusObj(buildConfig, statuses, expectedModules) {
	// If there are multiple builds going on for the same build config,
	// show the last created one. So start by sorting by 'created'
	const sortedStatuses = statuses.sort((a, b) => (
		new Date(b.created) - new Date(a.created)
	));
	// Then check if status is in active builds
	const statusObj = sortedStatuses.find(({ configId }) => configId === buildConfig.id) || {};
	if (!statusObj.status) {
		const builtModules = buildConfig.currentBuildModules;
		// If not in active builts, check if its been built previously or if versions mismatch
		if (!buildConfig.built) {
			statusObj.status = 'FAILED';
		} else if (modulesMatch(builtModules, expectedModules)
			// If built, check if the modules and versions match
			&& buildConfig.version === buildConfig.currentVersion) {
			statusObj.status = 'SUCCESS';
		} else { // If not, something has gone wrong
			statusObj.status = 'FAILED';
		}
	}
	return statusObj;
}

export default function generateTableData(buildConfigs, buildStatuses, autoIncludedModules) {
	const statuses = Object.values(buildStatuses);
	return buildConfigs.map((config) => {
		const expectedModules = [...config.additionalModules, ...(autoIncludedModules[config.version] || [])];
		const status = getBuildStatusObj(config, statuses, expectedModules);
		return {
			...status,
			expectedModules,
			...config,
		};
	});
}
